import { VARIANT_A } from '../../experiments/experimentDefaults';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { FlowManager } from '../../flow-management/FlowManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchMoveVerificationStepsACQ124 = {
  name: 'BranchMoveVerificationStepsACQ124',
  stateCheck: state => getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ124, [VARIANT_A]),
  rebuildFlow: (flow, _state, dispatch) => {
    const preVerificationSteps = [Step.LandingPage, Step.CodeVerification];
    const reconstructedPreVerificationSteps = FlowManager.removeSteps(Step.LandingPage, Step.CodeVerification)(getFlowSteps().preVerification);
    const reconstructedPostVerificationSteps = FlowManager.removeSteps(Step.Password)(getFlowSteps().postVerification);
    const postVerificationSteps = [Step.Password, ...reconstructedPreVerificationSteps, ...reconstructedPostVerificationSteps];
    const {
      postAccountCreation,
      postExistingAccountSelection
    } = getFlowSteps();
    const nextSteps = [...preVerificationSteps, ...postVerificationSteps, ...postAccountCreation, ...postExistingAccountSelection];
    dispatch(setFlow(nextSteps, preVerificationSteps, postVerificationSteps, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};